<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="centered">DEDICATION</p>
<p class="centered"><br/></p>
<p class="centered"><span style="font-style: italic;">To my wife</span></p>
<p class="centered"><span style="font-style: italic;">and</span></p>
<p class="centered"><span style="font-style: italic;">my sons</span></p>
<p class="centered"><span style="font-style: italic;">without whom</span></p>
<p class="centered"><span style="font-style: italic;">there is no story</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?2a259804